/** Lab type from WEBLAB (DSI-002-A1 §3 / §4). */
export type LabType = 'LABC' | 'LABM' | 'LABG';

export const LAB_TYPE: Readonly<Record<LabType, LabType>> = Object.freeze({
  LABC: 'LABC',
  LABM: 'LABM',
  LABG: 'LABG',
});

/** Query params for epidemiology / sensitivity ATB APIs (dates ISO YYYY-MM-DD). */
export interface EpidemiologySearchParams {
  patientId: string;
  labNr: number;
  dateFrom: string;
  dateTo: string;
  centroId?: number | null;
}

/** Result set 2 row — wspi_Search_Epidemiology (DSI-002-A1 §5.7.2.1), camelCase after cleanupData. */
export interface EpidemiologyRow {
  requisNr: string;
  extRequisNr: string;
  entryDate: string | Date;
  site: string;
  materialNr: number;
  materialName: string;
  cultureNr: number;
  culture: string;
  isolate: string;
  isolateNr: number;
  atb: boolean | number;
}

/** Result set 2 row — wspi_Search_SensitivityATB (DSI-002-A1 §6.7.2.1), camelCase after cleanupData. */
export interface SensitivityATBRow {
  requisCol: number;
  testRow: number;
  requisNr: string;
  extRequisNr: string;
  entryDate: string | Date;
  site: string;
  isolate: string;
  materialNr: number;
  materialName: string;
  atbNr: number;
  atbName: string;
  printSeq: number;
  result: string;
  backGroundColor: string | null;
}

export interface EpidemiologyResponse {
  data: EpidemiologyRow[];
  msgType: number;
  msgCode: string;
}

export interface SensitivityATBResponse {
  data: SensitivityATBRow[];
  msgType: number;
  msgCode: string;
  maxCol: number;
  maxRow: number;
}
